import AuthenticatedResource from 'resources/AuthenticatedResource'

export default class OrderDownloadResource extends AuthenticatedResource {
  static urlRoot = '/courses/:course_id/orders/download' as const;

  pk() {
    return 'download';
  }
}
